import React, { createContext } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { SelectedRecord } from './SelectedRecord';
import { Attendees } from '../../attendees/Attendees';
import { CalendarEvent } from '../../calendarEvent/CalendarEvent';
import { Save } from '../../save/calendar/Save';
import { NoSelectedRecord } from './NoSelectedRecord';
export const SelectedRecordContainerContext = createContext({});

import '../SelectedRecordContainer.scss';

export const SelectedRecordContainer = ({ item }) => {
  const isSaving = useSelector((state) => state.app.isLoading);
  const isPrivateEventSF = useSelector((state) => state.calendar.isPrivateEventSF);

  return (<>
    <div className={`selectedRecordContainer ${isSaving ? 'selectedRecordContainer-deactivated' : ''}`}>
      { item && !isPrivateEventSF ? <SelectedRecord item={item} isSelectedRecord={true} /> : <NoSelectedRecord isPrivateEventSF={isPrivateEventSF} />}
      <CalendarEvent />
      <Attendees />
      <Save />
    </div>
  </>);
};


SelectedRecordContainer.propTypes = {
  item: PropTypes.object,
};
